import { render } from "./App.vue?vue&type=template&id=4b0e525e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/s-planet01/Documents/Applications/Project/Web/80-Research/vue-zoloz-guide-selfie/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__